module.exports = __webpack_public_path__ + "img/icon_safari.7b2548b.png";